import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { saveAs } from "file-saver";
import { environment } from "src/environments/environment";

declare var window: any;
declare var cordova: any;

@Injectable({
  providedIn: "root",
})
export class FileUtilService {
  constructor(private httpClient: HttpClient) {}

  downloadFile(data, contentType: string, fileName: string) {
    const blob = new Blob([data], { type: contentType });
    if (environment.mobile) {
      this.saveOnMobile(blob, fileName);
    } else {
      saveAs(blob, fileName);
    }
  }

  saveOnMobile(blob: Blob, fileName: string) {
    let folderpath = cordova.file.cacheDirectory;
    window.resolveLocalFileSystemURL(folderpath, function (dir) {
      dir.getFile(
        fileName,
        { create: true },
        function (file) {
          file.createWriter(
            function (fileWriter) {
              fileWriter.write(blob);
              let finalPath = folderpath + fileName;
              cordova.plugins.fileOpener2.open(finalPath, blob.type, {
                error(err) {
                  // Unable to open file...
                  console.error(`Unable to open file ${fileName}`, err);
                },
                success() {
                  // Done.
                },
              });
            },
            function (err) {
              // Unable to create file...
              console.error(`Unable to create file ${fileName}`, err);
            }
          );
        },
        function (err) {
          // Unable to access to file system...
          console.error(`Unable to access to file system`, err);
        }
      );
    });
  }

  downloadFromUrl(url: string) {
    return this.httpClient.get(url, { responseType: "blob" });
  }

  convertToBase64(file: File): Promise<any> {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(file);
      reader.onerror = (error) => {
        console.log(
          "An error occured while trasforming file to Base64: ",
          error
        );
      };
    });
  }
}
